import { ActivatePartnershipInput } from "@/domain/dtos/inputs";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { CheckPartnershipRequest } from "../../dtos/requests";
import { PartnershipValidationResponse } from "../../dtos/responses";
import { PartnershipDataSource } from "./PartnershipDataSource";

export class PartnershipRemoteDataSource implements PartnershipDataSource {
  constructor(private readonly api: ApiService) {}

  async checkPartnership(
    params: CheckPartnershipRequest,
  ): Promise<PartnershipValidationResponse> {
    const { data } = await this.api.post<
      PartnershipValidationResponse,
      CheckPartnershipRequest
    >(Endpoints.check_partnership, params);
    return data!;
  }

  async activatePartnership(
    params: ActivatePartnershipInput,
  ): Promise<{ message: string }> {
    const { message } = await this.api.post(Endpoints.partnership, params);
    return { message: message || "Parceria ativada com sucesso" };
  }

  async removePartnership(partnershipId: number): Promise<{ message: string }> {
    const { message } = await this.api.delete(
      `${Endpoints.partnership}/${partnershipId}`,
    );
    return { message: message || "Parceria removida com sucesso" };
  }
}
